import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

const CHIPS = ["Yes", "No", "Unsure"];

export default function FollowupQuestion({ q, index, value, blank, onChange }) {
  const isNeg = (q.type || "").toLowerCase() === "negative";
  return (
    <div className={`border rounded-md p-5 ${blank ? "border-amber-400 bg-amber-50/40" : "border-zinc-200"}`}>
      <div className="flex items-start justify-between gap-3">
        <Label className="text-base text-zinc-900">{index + 1}. {q.question}</Label>
        {q.type && (
          <span
            data-testid={`qtype-${index}`}
            className={`shrink-0 text-[10px] font-semibold uppercase tracking-wide px-2 py-0.5 rounded-full ${isNeg ? "bg-amber-100 text-amber-700" : "bg-emerald-100 text-emerald-700"}`}
          >
            {isNeg ? "Rule-out" : "Pertinent +"}
          </span>
        )}
      </div>
      {q.why && <p className="text-xs text-zinc-400 mt-1">Why: {q.why}</p>}
      <div className="mt-3 flex gap-1.5">
        {CHIPS.map((c) => {
          const active = value === c;
          return (
            <button
              key={c} type="button"
              data-testid={`chip-${index}-${c.toLowerCase()}`}
              onClick={() => onChange(value === c ? "" : c)}
              className={`px-3 py-1 rounded-full border text-xs font-medium transition-colors ${active ? "bg-[#002FA7] border-[#002FA7] text-white" : "bg-white border-zinc-300 text-zinc-600 hover:border-zinc-400"}`}
            >{c}</button>
          );
        })}
      </div>
      <Textarea
        data-testid={`answer-${index}`}
        className={`mt-2 ${blank ? "border-amber-400 focus-visible:ring-amber-400" : ""}`}
        rows={2}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Patient's answer (or add detail)…"
      />
    </div>
  );
}
